export const Channels = ['デパコス', 'プチプラ', '韓国コスメ','オーガニック']
export type Channel = typeof Channels[number]

